// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__2ek61","cell":"ColumnAccessor_cell__3dX8P","firstCellAccent":"ColumnAccessor_firstCellAccent__1icBK"};